import { calculateVencimiento } from './dateHelpers';

/*
 * Vencimientos "en vivo" de financiación: cauciones y pases tomadores Hechos que el
 * cierre nocturno todavía no archivó en la colección `vencimientos`. Usa la misma
 * regla de fecha que el cierre (functions/index.js): caución = alta + días; pase = su
 * `fechaVencimiento` 'YYYY-MM-DD' en hora local.
 *
 * Sin dedupe contra los archivados: el cierre archiva y borra la caución/pase en el
 * mismo batch, así que no hay solapamiento real.
 *
 * @returns {Array} los documentos con `id` prefijado, `tipo`, `esEnVivo` y
 *   `fechaVencimiento` como Date.
 */
export const vencimientosFinanciacionEnVivo = (cauciones = [], pases = []) => {
    const deCauciones = cauciones
        .filter(c => c.operacion === 'Tomadora' && c.estado === 'Hecha')
        .map(c => {
            const fecha = calculateVencimiento(c.createdAt, Number(c.dias) || 0);
            return fecha
                ? { ...c, id: `live-caucion-${c.id}`, tipo: 'Caucion', esEnVivo: true, fechaVencimiento: fecha }
                : null;
        })
        .filter(Boolean);

    const dePases = pases
        .filter(p => p.operacion === 'Tomadora' && p.estado === 'Hecha' && p.fechaVencimiento)
        .map(p => {
            const [y, m, d] = String(p.fechaVencimiento).split('-').map(Number);
            if (!y || !m || !d) return null;
            return { ...p, id: `live-pase-${p.id}`, tipo: 'Pase', esEnVivo: true, fechaVencimiento: new Date(y, m - 1, d) };
        })
        .filter(Boolean);

    return [...deCauciones, ...dePases];
};
